import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function customEvent(eventName, endpoint, info) {
  // Cache the NWA library for linting issues.
  var _window = window,
      nwa = _window.nwa; // Publish the custom event with the provided info.

  if (nwa) {
    nwa.track(eventName, _objectSpread({
      eventName: eventName,
      endpoint: endpoint
    }, info));
  }
}